export default __webpack_public_path__ + "static/media/onboarding1.049389d0.png";